import { Alert } from "@mui/material";
import { type FC, useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

export const UnsavedIndicator: FC<{ isDirty: boolean }> = ({ isDirty }) => {
  const { t } = useTranslation();
  const [dirtyTime, setDireditTime] = useState<number | null>(null);
  const [date, setDate] = useState<number | null>(null);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setDireditTime(isDirty ? Date.now() : null);
  }, [isDirty]);

  useEffect(() => {
    const timerID = setInterval(() => setDate(Date.now()), 10000);
    return () => clearInterval(timerID);
  }, []);

  const ago = date && dirtyTime ? Math.round((date - dirtyTime) / 1000 / 60) : 0;
  return ago > 2 ? (
    <Alert severity="warning" title={t("Save your work regularly to avoid losing your changes")}>
      <Trans>Last saved {{ ago }} minutes ago</Trans>
    </Alert>
  ) : (
    <></>
  );
};
